import request from '@/utils/request'

export function getVerifyCode(data) {
  return request({
    url: '/common/verify/getcode',
    method: 'post',
    data: data
  })
}